<template>

  <EntityManager
      heading="Продажби"
      heading-create="Нова продажба"
      heading-modify="Редактиране на продажба"
      heading-delete="Изтриване на продажба"
      message-delete="Избраната продажба ще бъде изтрита. Сигурни ли сте?"
      resource="/sale"
      ref="em"
      @filter="onFilter" @select="onSelect"
      >
    <template #filter>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">Месец:</span>
        <Calendar view="month" v-model="period" dateFormat="MM yy"
          :yearNavigator="true" yearRange="2020:2030"
          :showIcon="true" :showButtonBar="true"
          @month-change="$refs.em.refresh()"
          />
      </div>
    </template>
    <template #buttons-left>
      <Button label="Фактуриране" icon="pi pi-money-bill" :disabled="!selected" @click="$refs.invoice.open(selected)"></Button>
    </template>
    <template #table>
      <Column field="number" header="Номер" style="flex: 0 0 6em" bodyClass="right"></Column>
      <Column field="date" header="Дата" style="flex: 0 0 8em" bodyClass="right">
        <template #body="props">
          {{new Date(props.data.date).toLocaleDateString()}}
        </template>
      </Column>
      <Column field="contragent.name" header="Контрагент">
      </Column>
      <Column field="store.name" header="Склад" footerClass="right">
        <template #footer>
          Общо:
        </template>
      </Column>
      <Column field="paymentMethod" header="Вид плащане">
        <template #body="props">
          {{getPaymentMethod(props.data.paymentMethod)}}
        </template>
      </Column>
      <Column field="netto" header="Стойност" style="flex: 0 0 10em" bodyClass="right" headerClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.netto)}}
        </template>
        <template #footer>
          {{$utils.currency(0)}}
        </template>
      </Column>
      <Column field="vat" header="ДДС" style="flex: 0 0 10em" bodyClass="right" headerClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.vat)}}
        </template>
        <template #footer>
          {{$utils.currency(0)}}
        </template>
      </Column>
      <Column field="total" header="Общо" style="flex: 0 0 10em" bodyClass="right" headerClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.total)}}
        </template>
        <template #footer>
          {{$utils.currency(0)}}
        </template>
      </Column>
      <Column field="paid" header="Плащане" bodyClass="center" style="flex: 0 0 8em" >
        <template #body="props">
          <Checkbox v-on:change="setPaymentStatus(props.data)" v-model="props.data.paid" :binary="true" class="p-checkbox-sm"/>
        </template>
      </Column>
    </template>
    <template v-slot:form="props">
      <Sale v-model="props.entity"/>
    </template>
    <template v-slot:form-footer="props">
      <div class="p-field-checkbox">
        <Checkbox id="unofficial" v-model="props.entity.unofficial" :binary="true"/>
        <label for="unofficial">&nbsp;Продажбата е неофициална</label>
      </div>
    </template>
  </EntityManager>
  <InvoiceCreator ref="invoice"
    @apply="invoiceVisible = true"
    title="Издаване на фактура">
  </InvoiceCreator>
</template>

<script>

export default {
  data() {
    return {
      contragents : [],
      stores : [],
      paymentStatus: ['Платен', 'За плащане'],
      date: new Date(),
        selected: null,
      tbl: {
        edit: false,
      },
      invoicing: false,
      invoiceVisible: false,
      paymentMethods: {
        "cash": "В брой",
        "bank": "По сметка",
        "ppp": "Пощенски паричен превод",
        "card": "С карта",
        "voucher": "С ваучер",
      },
    }
  },

  methods: {
    getPaymentMethod(code) {
      return this.paymentMethods[code];
    },
    setPaymentStatus(sale) {
      this.$http.get('/sale/' + sale.id + '/' + sale.paid);
      console.log(sale.paid)
    },
    onSelect(data) {
      this.selected = data;
    },
    onRead(event) {
      this.tbl.selected = null;
      event.onSuccess(event.item);
      this.item = event.item;
    },
    changeDocument(document) {
      this.$emit('update:modelValue', document)
    },
    total(f) {
      var total = 0;
      for(const item of this.item.items) {
        total += f(item);
      }
      return total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    currency(f) {
      return f.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    count() {
      return this.item.items.length;
    },
    onFilter(params) {
      params.period = this.getPeriodFromDate();
    },
    getPeriodFromDate() {
      return this.date.getFullYear() * 100 + this.date.getMonth() + 1;
    }
  },
  computed: {
    period: {
      get() {
        return this.date;
      },
      set(date) {
        this.date = date;
        this.$refs.em.refresh();
      }
    },
  }
}
</script>

<style>
.p-checkbox-sm {
  width: 15px !important;
  height: 15px !important;
}

.p-checkbox-sm .p-checkbox-icon {
  font-size: 9px !important;
}

.p-checkbox-sm .p-checkbox-box {
  border-width: 1px !important;
  width: 15px !important;
  height: 15px !important;
}

.document-preview {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}

</style>
